import { ReactNode } from "react";

import { Box, useBreakpointValue } from "@/storybook-components";
import StickyActionBar from "./sticky-action-bar";

function RowLayout({
  aboutContent,
  mainContent,
  actions
}: {
  aboutContent: ReactNode;
  mainContent: ReactNode;
  actions?: { component: ReactNode; position: "left" | "right" }[];
  splitActions?: boolean;
}) {
  const isMobile = useBreakpointValue({ base: true, lg: false }) || false;

  return (
    <Box px={{ base: 4, md: 6 }}>
      {aboutContent}
      <Box position="relative" mt={{ base: 4, lg: 0 }}>
        {isMobile ? (
          <>
            {mainContent}
            <Box mt={4} position="sticky" bottom={0} zIndex={10}>
              <StickyActionBar actions={actions} />
            </Box>
          </>
        ) : (
          <>
            <Box mb={4} position="sticky" top={0} zIndex={10}>
              <StickyActionBar actions={actions} />
            </Box>
            {mainContent}
          </>
        )}
      </Box>
    </Box>
  );
}

export default RowLayout;
